import '../Scss/app.scss';

// Components
import events from './helpers/events';
import general from './core/general';
const modules = [general, events];
modules.forEach(module => {
  module();
});
const components = [{
  el: 'header',
  fileName: 'core/header'
}, {
  el: '.accordion',
  fileName: 'components/accordion'
}, {
  el: '.js-filter-checkbox',
  fileName: 'components/category-filter'
}, {
  el: '.select-dropdown',
  fileName: 'components/dropdown'
}, {
  el: '.modal',
  fileName: 'components/dialog'
}, {
  el: '.tx-powermail',
  fileName: 'vendors/powermail/Form'
}, {
  el: '.media__video--wrap',
  fileName: 'components/video-player'
}, {
  el: '.scroll-shadow',
  fileName: 'components/scroll-shadow'
}, {
  el: '.js-filter-group',
  fileName: 'components/product-filter'
}, {
  el: '.unmute-btn',
  fileName: 'components/mute-btn'
}, {
  el: '.swiped-cards',
  fileName: 'components/swiped-cards'
}, {
  el: '.downloads-section',
  fileName: 'components/downloads-plugin'
}, {
  el: '.scrollable-ce',
  fileName: 'components/scrollable-ce'
}, {
  el: '.ce-tab',
  fileName: 'components/tabs'
}, {
  el: '.basicRotate',
  fileName: 'components/image_3d'
}, {
  el: '.ce-slider',
  fileName: 'components/slider'
}, {
  el: '.tx-powermail',
  fileName: 'vendors/powermail/Form'
}, {
  el: '.custom-select',
  fileName: 'components/select'
}, {
  el: '.js-timeline',
  fileName: 'components/timeline'
}, {
  el: '.news-list-view',
  fileName: 'components/news'
}, {
  el: '.find-contact_form',
  fileName: 'components/contact-finder'
}, {
  el: '.js-sticky-banner',
  fileName: 'components/sticky-banner'
}, {
  el: '.js-back-to-top',
  fileName: 'components/back-to-top-button'
}];
const componentImport = async (el, fileName) => {
  if (!document.querySelector(el)) return;
  const module = await import(`./${fileName}`);
  // Initialize module
  if (typeof module === 'function') {
    module();
  } else if (typeof module === 'object' && typeof module.default === 'function') {
    module.default();
  }
};
components.forEach(component => {
  const {
    el,
    fileName
  } = component;
  componentImport(el, fileName);
});